const guiColors = {
    'motion-primary': '#625e97',
    'motion-primary-transparent': 'hsla(240,21%,19%,0.35)',
    'motion-tertiary': '#454171',

    'looks-secondary': '#625e97',
    'looks-secondary-light': '#8d87cf',
    'looks-secondary-lighter': '#b6aff3',
    'looks-transparent': 'hsla(240,21%,19%,0.35)',
    'looks-light-transparent': 'hsla(261, 100%, 50%, 0.15)',
    'looks-secondary-dark': '#2a293f',
    'looks-secondary-darker': '#1c1c2b',
    'looks-secondary-deep-dark': '#12121a',

    'extensions-primary': '#625e97',
    'extensions-tertiary': '#444171',
    'extensions-transparent': 'hsla(240,21%,19%,0.35)',
    'extensions-light': '#8d87cf',

    'drop-highlight': '#7a74bb'
};

const blockColors = {
    checkboxActiveBackground: '#625e97',
    checkboxActiveBorder: '#5b5788'
};

export {
    guiColors,
    blockColors
};